import DataTableSkeleton from '@/components/ui/DataTableSkeleton'
import Skeleton from '@/components/ui/Skeleton'

/*
 * Market · Live before its first response: the LOADED board, block for block,
 * from the loaded components' own box classes, so nothing moves when the rows
 * land (10 rows, the URL's own default):
 *
 *   toolbar        44 / 36 @lg   the three breadth chips (`BreadthFilter`'s `h-11 lg:h-8`), the
 *                                market-status pill, the sector menu and the round Refresh button
 *   table + pager  DataTable's `h-table-head` band, ten two-line `h-table-row-two-line` rows,
 *                  then `Pagination`'s own `mt-6` and its 44 below `lg` / 32 above
 *
 * Bars only, no words, so nothing here can be mistaken for the loaded content.
 * The page's own TitleRow is the exception, and ScreenLayout draws it (see
 * LiveMarketScreen). The status line and any failed-poll bar are loaded-only.
 */

/** The three chips, the status pill, the sector menu and Refresh. */
function ToolbarSkeleton() {
  return (
    <div className="flex flex-wrap items-center gap-4">
      <div className="grid min-w-0 flex-1 basis-80 grid-cols-3 gap-2">
        {[0, 1, 2].map((chip) => (
          <Skeleton key={chip} className="h-11 lg:h-8" />
        ))}
      </div>
      <Skeleton className="h-6 w-26" />
      <div className="flex min-w-0 items-center gap-2">
        <Skeleton className="h-11 w-28 rounded-sm lg:h-9" />
        <Skeleton className="size-11 shrink-0 rounded-full lg:size-9" />
      </div>
    </div>
  )
}

export function LiveMarketBoardSkeleton() {
  return (
    <>
      <ToolbarSkeleton />
      <div>
        <DataTableSkeleton rows={10} columns={6} rowHeight="lg" />
        <div className="mt-6 h-11 lg:h-8" />
      </div>
    </>
  )
}
